let bannerData = [
    {
        id:1,
        img: "assets/images/banner.png",
        subheading: "STOCK IS LIMITED1",
        heading: "End of Season clearance Sale upto 30%",
        button: "Go to Shop"

    },
    {
        id:2,
        img: "assets/images/banner.png",
        subheading: "STOCK IS LIMITED2",
        heading: "End of Season clearance Sale upto 30%",
        button: "Go to Shop"

    },
    {
        id:3,
        img: "assets/images/banner.png",
        subheading: "STOCK IS LIMITED3",
        heading: "End of Season clearance Sale upto 30%",
        button: "Go to Shop"

    },
]
module.exports = bannerData;
